var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Instance',{attrs:{"instance":"year","instance-name":"year","create":d => _vm.yearApi.create(d),"delete":d => _vm.yearApi.remove(d),"update":d => _vm.yearApi.update(d),"get":d => _vm.yearApi.get(d),"upsert":_vm.upsert,"columns":_vm.columns,"hideDelete":!_vm.isCommonAdmin}})
}
var staticRenderFns = []

export { render, staticRenderFns }